const func = $target => {

    var $productType = $target.find('#productType'),
        $implants = $target.find('[data-type="implants"]'),
        $implantBrands = $implants.find('#implantBrand'),
        $implantSurgeryTray = $implants.find('#implantSurgeryTray'),

        $invisalign = $target.find('[data-type="invisalign"]'),
        $invisalignProvider = $invisalign.find('#invisalignProvider'),
        $preference = $target.find('#preference');

    // remove all "optional" labels
   

    // $productType.on('change', function() {

    //     if (this.value == 'implants') {
    //         $implants.removeClass('d-none');
    //         $invisalign.addClass('d-none');
    //         $invisalign.find('input,select').prop('required',false);
    //     } else if(this.value == 'invisalign') {
    //         $invisalign.removeClass('d-none');
    //         $implants.addClass('d-none');
    //         $implants.find('input,select').prop('required',false);
    //     }

    // });

    $implantBrands.on('change', function() {

        var $implantBrandOther = $implants.find('[data-type="implant-brand-other"]'),
            $otherInput = $implantBrandOther.find('input[type=text]');

        if(this.value == 'other') {
            $implantBrandOther.removeClass('d-none');
            $otherInput.prop('required',true);
        } else if(!$implantBrandOther.hasClass('d-none')) {
            $implantBrandOther.addClass('d-none');
            $otherInput.prop('required',false);
        }
    });

    $implantSurgeryTray.on('change', function() {

        var $implantSurgeyTray = $implants.find('[data-type="implant-surgery-tray-other"]'),
            $otherInput = $implantSurgeyTray.find('input[type=text]');

        if(this.value == 'other') {
            $implantSurgeyTray.removeClass('d-none');
            $otherInput.prop('required',true);
        } else if(!$implantSurgeyTray.hasClass('d-none')) {
            $implantSurgeyTray.addClass('d-none');
            $otherInput.prop('required',false);
        }
    }); 
    
    $invisalignProvider.on('change', function() {

        var $invisalignAlert = $invisalign.find('[data-type="invisalign-provider-alert"]'),
            $invisalignProviderDetails = $invisalign.find('[data-type="invisalign-provider-details"]'),
            $invisalignGoProviderDetails = $invisalign.find('[data-type="invisalign-go-provider-details"]');

        $invisalignAlert.addClass('d-none');
        $invisalignProviderDetails.addClass('d-none');
        $invisalignGoProviderDetails.addClass('d-none');

        $invisalignProviderDetails.find('input').prop('required',false);
        $invisalignGoProviderDetails.find('input').prop('required',false);

        $invisalign.find('.text-muted').remove();

        if(this.value == 'invisalignProvider') {

            $invisalignProviderDetails.removeClass('d-none').find('input').prop('required',true);
                   
        } else if(this.value == 'invisalignGoProvider') {

            $invisalignGoProviderDetails.removeClass('d-none');
            $invisalignGoProviderDetails.find('input').prop('required',true);     
           
        } else if(this.value == 'invisalignProviderBoth') {

            $invisalignProviderDetails.removeClass('d-none');
            $invisalignGoProviderDetails.removeClass('d-none');
            $invisalignAlert.removeClass('d-none');

            $invisalignProviderDetails.find('input').prop('required',true);   
            $invisalignGoProviderDetails.find('input').prop('required',true);   

        }

    });

    if($preference[0]) {
        console.log('preference');
        $invisalign.find('input,select').prop('required',false);
    }

    $preference.on('change', function() {
        if(this.value == 'new') {
            $invisalign.removeClass('d-none');
            $invisalign.find('#invisalignOrthodontist').prop('required',true);
            $invisalignProvider.prop('required',true);
        } else {
            $invisalign.addClass('d-none');
            $invisalign.find('input,select').prop('required',false);
        }
    });

};

export default func;